module.exports = []


//////////////////
// WEBPACK FOOTER
// ./.cache/redirects.json
// module id = ./.cache/redirects.json
// module chunks = 231608221292675